export class BaseAddressDto {
  id: number;
  firstName: string;
  lastName: string;
  buildingName?: string;
  buildingNumber?: string;
  street: string;
  city: string;
  country?: string;
  postCode?: string;
  countryCode?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  latitude: number;
  longitude: number;
}
